export class mdlSaudiPostAddress {
    public  additionalNumber: any
    public  buildingNumber: any
    public  city: any
    public  district: any
    public  postCode: any
    public  streetName: any
    public  logID: any
    public  IqamaNo: any
    public  DOB: any
    public  Lng: any
    public  YakeenLogIDSudiPost: any
  }


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlSaudiPostAddress.ts